import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '../../../libs/styled.es.js';
import ReactDOM from 'react-dom';

const ModalConfirm = (props) => {
    const { show, className, title, message, cancelText, okText, cancel, ok, hideOk, hideCancel, } = props;
    const MyModalConfirm = styled.div `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100000;
    overflow: hidden;
    outline: 0;
    background-color: rgba(0, 0, 0, 0.5);
    height: 100vh;
    &.off {
      opacity: 0;
      visibility: hidden;
      filter: blur(8px);
      transform: scale(0.33);
      box-shadow: 1rem 0 0 rgba(black, 0.2);
    }
    &.show {
      box-shadow: -2rem 2rem 2rem rgba(black, 0.2);
      filter: blur(0);
      transform: scale(1);
      opacity: 1;
      visibility: visible;
    }
  `;
    const MyModalDialog = styled.div `
    transform: translate(0, 0);
    transition: -webkit-transform 0.3s ease-out;
    transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;
    position: relative;
    width: 100%;
    height: 100%;
    pointer-events: none;
    @media (min-width: 576px) {
      max-width: 500px;
      margin: 1.75rem auto;
    }
  `;
    const Content = styled.div `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @include center();
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    width: fit-content;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    outline: 0;
    box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    width: 80%;
  `;
    const Messages = styled.div `
    padding: 22px;
  `;
    const Title = styled.div `
    width: 100%;
    text-align: center;
    font-size: 17px;
    font-weight: 500;
  `;
    const Message = styled.div `
    padding-top: 16px;
    width: 100%;
    text-align: left;
    font-size: 14px;
  `;
    const ButtonGroup = styled.div `
    display: flex;
    justify-content: space-between;
    padding-right: 22px;
    padding-left: 22px;
    padding-bottom: 22px;
  `;
    const Button = styled.button(({ theme }) => `
      border-radius: 6px;
      font-size: 13px;
      padding: 8px 0;
      flex: 1 1;
      &.btn-cancel {
        border: 0.5px solid ${theme.brand.primary};
        background: #fff;
        color: ${theme.brand.primary};
      }
      &.btn-ok {
        background: ${theme.brand.primary};
        color: #fff;
        border: none;
      }
  `);
    const Mr15 = styled.div `
    margin-right: 15px;
  `;
    return typeof document !== 'undefined' && show
        ? ReactDOM.createPortal(React.createElement(MyModalConfirm, { className: `${show ? 'show' : 'off'} ${className || ''}` },
            React.createElement(MyModalDialog, null,
                React.createElement(Content, null,
                    React.createElement(Messages, null,
                        title && React.createElement(Title, null, title),
                        message && React.createElement(Message, null, message)),
                    React.createElement(ButtonGroup, null,
                        !hideCancel && (React.createElement(Button, { className: "btn-cancel", onClick: cancel }, cancelText || `Hủy`)),
                        !hideCancel && !hideOk && React.createElement(Mr15, null),
                        !hideOk && (React.createElement(Button, { className: "btn-ok", onClick: ok }, okText || `Xóa`)))))), document.body)
        : null;
};
ModalConfirm.propTypes = {
    show: PropTypes.bool.isRequired,
    cancel: PropTypes.func,
    ok: PropTypes.func,
    className: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string,
    cancelText: PropTypes.string,
    okText: PropTypes.string,
    hideOk: PropTypes.bool,
    hideCancel: PropTypes.bool,
};

export { ModalConfirm };
